import React, { useState, useEffect } from 'react'
import spinner from '../../../public/Spinner.gif'
import bdLogo from '../../../public/Bitmap.png'

export default function SubscriptionExpired({ customerId }) {
    async function createStripeSession() {
        var myHeaders = new Headers()
        myHeaders.append(
            'Authorization',
            `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`
        )
        myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

        var urlencoded = new URLSearchParams()
        urlencoded.append('success_url', `${window.location.origin}/subscribe-success`)
        urlencoded.append('cancel_url', `${window.location.href}`)
        urlencoded.append('line_items[0][price]', 'price_1Hr6mJLTZmj0aAlElRVUPFOz')
        urlencoded.append('line_items[0][quantity]', '1')
        urlencoded.append('mode', 'subscription')

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow',
        }

        fetch('https://api.stripe.com/v1/checkout/sessions', requestOptions)
            .then((response) => response.text())
            .then((result) => {
                window.location.href = JSON.parse(result).url
            })
            .catch((error) => console.log('error', error))
    }

    useEffect(() => {
        createStripeSession()
    }, [])


    return (
        <div className='subscription-success-container'>
            <div className='nav-bar'>
                <a
                    href='https://branding.cards'
                    alt='bd-logo'
                    className='bd-logo-container'
                >
                    <img className='bd-logo' src={bdLogo} alt='Brand Deck Logo' />
                </a>
            </div>

            <div className='subscription-success-render'>
                <img
                    className='subscription-success-image'
                    src={spinner}
                    alt='spinner'
                />
            </div>
        </div>
    )
}

